import z from 'zod';

export const meetingContributionSchema = (minAmount: number) =>
  z
    .object({
      contributionCurrency: z.string(),
      contributionAmount: z
        .number()
        .min(minAmount)
        .nonnegative('Contribution amount must be positive'),
      prayerRequests: z.array(z.string()),
      tip: z.number().nonnegative('Tip amount must be positive'),
      sponsor_magazine: z.number().nonnegative('Sponsor magazine amount must be positive'),
      paymentMethod: z.enum(['debit_credit', 'manual_payment']),
    })
    .superRefine((data, ctx) => {
      if (data.paymentMethod === 'debit_credit') {
        if (data.contributionAmount > 1000000) {
          ctx.addIssue({
            code: z.ZodIssueCode.too_big,
            type: 'number',
            maximum: 1000000,
            inclusive: true,
            path: ['contributionAmount'],
            message: 'Maximum contribution amount for debit/credit payments is 1,000,000',
          });
        }
      }
    });
